import React, { useState } from 'react';

import FullscreenChart from 'components/Layout/MobileShell/FullscreenChart';
import CabecalhoGraficoMobile from 'components/Windx/Mobile/CabecalhoGrafico';
import GraficoSM from 'components/Windx/GraficoSM';

import './index.scss';

/**
 * WEOL-SM Semanal no mobile (spec Windx mobile, Task 12).
 *
 * Espelho da tela do WEOL-SH: mesmo chrome (`CabecalhoGraficoMobile`, que ja
 * traz card de consulta, barra fixa, painel e seletor), mesmo tratamento de
 * tela cheia em retrato, e o `GraficoSM` reusado sem alteracao.
 *
 * O painel mostrar Patamar e esconder Simulacoes Antigas vem de graca do
 * `useControlPanelRules` (a regra e por `tela`) — nao ha nada a replicar aqui.
 *
 * O botao de tela cheia mora no cabecalho do card do grafico
 * (`ChartComSliders`), como no prototipo. Por isso `onExpandir` so vai na
 * instancia inline: dentro do overlay nao ha o que expandir.
 */
export default function SemanalMobile() {
  const [carregando, setCarregando] = useState(false);
  const [telaCheia, setTelaCheia] = useState(false);

  return (
    <div className="windx-sm-mobile" data-testid="windx-sm-mobile">
      <CabecalhoGraficoMobile tela="sm" carregando={carregando}>
        <div className="windx-sm-mobile-grafico">
          {!telaCheia && (
            <GraficoSM
              onLoadingChange={setCarregando}
              onExpandir={() => setTelaCheia(true)}
            />
          )}
        </div>
      </CabecalhoGraficoMobile>

      <FullscreenChart
        open={telaCheia}
        dismiss={() => setTelaCheia(false)}
        title="Geração eólica — Semanal"
        landscape
      >
        {telaCheia && (
          <div className="windx-sm-mobile-fullscreen">
            <GraficoSM onLoadingChange={setCarregando} />
          </div>
        )}
      </FullscreenChart>
    </div>
  );
}
